<button
    [disabled]="disabled"
    [ngClass]="{
        'kk-btn': true,
        'kk-btn_svg': true,
        'kk-btn_secondary': this.variant === 'secondary',
        'kk-btn_blue': this.variant === 'blue',
        'full-width': fullWidth,
        'full-height': fullHeight,
        'icon-only': iconOnly
    }"
    [type]="type"
>
    <app-svg-icon *ngIf="iconPosition === 'before'" [iconName]="iconName"></app-svg-icon>
    <span [ngClass]="{ 'kk-visuallyhidden': iconOnly }"><ng-content></ng-content></span>
    <app-svg-icon *ngIf="iconPosition === 'after'" [iconName]="iconName"></app-svg-icon>
</button>
